/* V103 — signal feed chrome + functional newsletter/footer. Additive; does not touch the ASCII renderer. */
(()=>{
  const qs=(s,r=document)=>r.querySelector(s);
  const esc=s=>String(s??'').replace(/[&<>'"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));
  const money=v=>{
    const n=Number(v);return Number.isFinite(n)?`$${n%1?n.toFixed(2):n.toFixed(0)} AUD`:'';
  };

  function footerMarkup(){
    const logoSrc=qs('.brand-logo-image')?.src||'';
    return `
<section class="wc-site-end" id="wcSiteEnd" aria-label="Store information">
  <div class="wc-end-trust" aria-label="Shopping assurances">
    <div class="wc-end-trust-item"><strong>Secure checkout</strong><span>Processed by Shopify</span></div>
    <div class="wc-end-trust-item"><strong>Free shipping $95+</strong><span>Eligible orders</span></div>
    <div class="wc-end-trust-item"><strong>Returns available</strong><span>Subject to return policy</span></div>
    <div class="wc-end-trust-item"><strong>Size guidance</strong><span>Product-specific fit help</span></div>
  </div>
  <div class="wc-footer-newsletter">
    <div>
      <span class="wc-footer-eyebrow">WiFi Cowboy / transmissions</span>
      <h2>Stay in the loop</h2>
      <p>New drops, restocks and field notes. Join the list for the next signal.</p>
    </div>
    <form class="wc-newsletter-form" method="post" action="/contact#contact_form" accept-charset="UTF-8">
      <input type="hidden" name="form_type" value="customer">
      <input type="hidden" name="utf8" value="✓">
      <input type="hidden" name="contact[tags]" value="newsletter">
      <label class="visually-hidden" for="wcNewsletterEmail">Email address</label>
      <input id="wcNewsletterEmail" name="contact[email]" type="email" inputmode="email" autocomplete="email" placeholder="Email address" required>
      <button type="submit">Join</button>
    </form>
  </div>
  <div class="wc-footer-links">
    <div class="wc-footer-brand">
      ${logoSrc?`<img src="${esc(logoSrc)}" alt="WiFi Cowboy" loading="lazy">`:''}
      <p>Internet-born apparel, graphics and objects built to exist in the real world.</p>
    </div>
    <nav class="wc-footer-col" aria-label="Shop">
      <h3>Shop</h3>
      <button type="button" data-wc-footer-action="all">Shop all</button>
      <button type="button" data-wc-footer-action="men">Men</button>
      <button type="button" data-wc-footer-action="women">Women</button>
      <a href="#socialLookbook">wifi community</a>
    </nav>
    <nav class="wc-footer-col" aria-label="Customer care">
      <h3>Customer care</h3>
      <button type="button" data-wc-footer-action="size-guide">Size guide</button>
      <a href="/policies/shipping-policy">Shipping</a>
      <a href="/policies/refund-policy">Returns & exchanges</a>
      <a href="/account">Track order / account</a>
    </nav>
    <nav class="wc-footer-col" aria-label="Information">
      <h3>Information</h3>
      <a href="/pages/contact">Contact</a>
      <a href="/pages/faq">FAQ</a>
      <a href="/policies/privacy-policy">Privacy policy</a>
      <a href="/policies/terms-of-service">Terms & conditions</a>
    </nav>
  </div>
  <div class="wc-footer-bottom">
    <div class="wc-footer-legal">WiFi Cowboy © ${new Date().getFullYear()} · Designed in Australia</div>
    <div class="wc-footer-payments" aria-label="Checkout payment marks">
      <span class="wc-footer-payment">VISA</span>
      <span class="wc-footer-payment">MC</span>
      <span class="wc-footer-payment">AMEX</span>
      <span class="wc-footer-payment apple"> Pay</span>
      <span class="wc-footer-payment">Shop Pay</span>
    </div>
  </div>
</section>`;
  }

  function installFooter(){
    const ascii=qs('.ascii-footer');if(!ascii)return;

    /* Direct product deep-links can open the PDP before DOMContentLoaded.
       V127 may therefore move the ASCII chapter into .pdp-shell before this
       footer is installed. Never inject the real site footer into the PDP. */
    let existing=qs('#wcSiteEnd');
    if(existing?.closest('.pdp-shell')){
      document.body.appendChild(existing);
    }

    if(!existing){
      if(ascii.closest('.pdp-shell')){
        document.body.insertAdjacentHTML('beforeend',footerMarkup());
      }else{
        ascii.insertAdjacentHTML('beforebegin',footerMarkup());
      }
      existing=qs('#wcSiteEnd');
    }

    qs('[data-wc-footer-action="all"]')?.addEventListener('click',()=>qs('#grid')?.scrollIntoView({behavior:'smooth',block:'start'}));
    qs('[data-wc-footer-action="men"]')?.addEventListener('click',()=>{qs('#menEdit')?.click();setTimeout(()=>qs('#grid')?.scrollIntoView({behavior:'smooth',block:'start'}),60)});
    qs('[data-wc-footer-action="women"]')?.addEventListener('click',()=>{qs('#womenEdit')?.click();setTimeout(()=>qs('#grid')?.scrollIntoView({behavior:'smooth',block:'start'}),60)});
    qs('[data-wc-footer-action="size-guide"]')?.addEventListener('click',()=>{
      if(typeof openSizeGuide==='function')openSizeGuide();
      else qs('[data-size-guide-open]')?.click();
    });
  }

  function icon(name,extra=''){
    const icons={
      heart:'<path d="M12 21s-7-4.4-9.3-8.4C.7 9.2 2.6 5 6.5 5c2.1 0 3.5 1.2 4.3 2.3C11.6 6.2 13 5 15.1 5c3.9 0 5.8 4.2 3.8 7.6C16.6 16.6 12 21 12 21Z"/>',
      comment:'<path d="M21 11.5a8.2 8.2 0 0 1-8.5 8.1c-1.2 0-2.4-.2-3.4-.7L4 20l1.3-4.2A7.8 7.8 0 0 1 4 11.5a8.2 8.2 0 0 1 8.5-8.1A8.2 8.2 0 0 1 21 11.5Z"/>',
      send:'<path d="M21 3 10.2 13.8M21 3l-6.7 18-4.1-7.2L3 9.7 21 3Z"/>',
      save:'<path d="M6 3.5h12v17L12 17l-6 3.5v-17Z"/>'
    };
    return `<svg class="wc-social-icon ${extra}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${icons[name]}</svg>`;
  }

  function currentLook(index){
    try{
      const story=(typeof WC_GENDER_STORY!=='undefined'&&typeof activeEdit!=='undefined')?WC_GENDER_STORY[activeEdit]:null;
      return {story,look:story?.looks?.[index]||null,edit:(typeof activeEdit!=='undefined'?activeEdit:'men')};
    }catch{return {story:null,look:null,edit:'men'}}
  }

  function productFor(id){
    try{return (id&&typeof byId==='function')?byId(id):null}catch{return null}
  }

  function socialCaption(look,index,edit){
    const base=look?.meta||'WiFi Cowboy field look';
    const lines=edit==='women'
      ?['Signal found. Built around the piece, not around the algorithm.','Colour, proportion, graphic. Everything else gets out of the way.','Off-duty uniform, online signal.','Seen outside the browser window.']
      :['Offline proof of an internet-born uniform.','Built for the feed. Better in the street.','Graphic signal, real-world noise.','Connected everywhere. Logged out here.'];
    return `<strong>wificowboy.shop</strong> ${esc(lines[index%lines.length])}<br><span>${esc(base)}</span>`;
  }

  function augmentLookbook(index){
    const modal=qs('#lookbookModal'),copy=qs('.wc-lookbook-modal-copy',modal);if(!modal||!copy)return;
    const {look,edit}=currentLook(index);if(!look)return;
    const p=productFor(look.product);
    const productName=p?.name||look.meta||'View product';
    const productImage=p?.front||look.src;
    const productPrice=money(p?.price);
    copy.querySelectorAll('.wc-social-post-head,.wc-social-post-body,.wc-social-post-actions,.wc-social-product,.wc-social-post-date').forEach(n=>n.remove());
    copy.insertAdjacentHTML('afterbegin',`
      <div class="wc-social-post-head">
        <div class="wc-social-avatar">WC</div>
        <div class="wc-social-author"><strong>wificowboy.shop</strong><span>wifi community · editorial</span></div>
        <div class="wc-social-more" aria-hidden="true">···</div>
      </div>
      <div class="wc-social-post-body">
        <span class="wc-social-post-index">${edit==='women'?'WOMEN':'MEN'} / FIELD NOTE ${String(index+1).padStart(2,'0')}</span>
        <p class="wc-social-post-caption">${socialCaption(look,index,edit)}</p>
      </div>
      <div class="wc-social-post-actions" aria-hidden="true">${icon('heart')}${icon('comment')}${icon('send')}${icon('save','wc-social-save')}</div>
      <button class="wc-social-product" type="button" data-wc-social-product="${esc(look.product||'')}">
        <img src="${esc(productImage)}" alt="" loading="eager" decoding="async">
        <span class="wc-social-product-copy"><strong>${esc(productName)}</strong><span>${esc(productPrice||'View product')}</span></span>
        <span class="wc-social-product-arrow">→</span>
      </button>
      <div class="wc-social-post-date">WiFi Cowboy · 20 September 2026</div>
    `);
    copy.querySelector('[data-wc-social-product]')?.addEventListener('click',e=>{
      const id=e.currentTarget.dataset.wcSocialProduct;if(!id)return;
      try{if(typeof wcCloseLookbook==='function')wcCloseLookbook();const prod=productFor(id);if(prod&&typeof openPDP==='function')openPDP(prod.id);}catch{}
    });
    ensureLookNav(index);
  }

  function ensureLookNav(index){
    const panel=qs('.wc-lookbook-modal-panel');if(!panel)return;
    panel.querySelectorAll('.wc-lookbook-nav').forEach(n=>n.remove());
    panel.insertAdjacentHTML('beforeend','<button class="wc-lookbook-nav prev" type="button" aria-label="Previous look">‹</button><button class="wc-lookbook-nav next" type="button" aria-label="Next look">›</button>');
    const {story}=currentLook(index),count=story?.looks?.length||0;
    const go=dir=>{if(!count)return;const next=(index+dir+count)%count;try{if(typeof wcOpenLookbookItem==='function')wcOpenLookbookItem(next);augmentLookbook(next)}catch{}};
    qs('.wc-lookbook-nav.prev',panel)?.addEventListener('click',()=>go(-1));
    qs('.wc-lookbook-nav.next',panel)?.addEventListener('click',()=>go(1));
  }

  function tuneLookbookLabels(){
    const t=qs('#socialLookbookTitle');if(t)t.textContent='wifi community';
    const b=qs('#socialLookbookViewAll');if(b)b.innerHTML='Shop the edit <span>→</span>';
  }

  function init(){
    installFooter();tuneLookbookLabels();
    document.addEventListener('click',e=>{
      const card=e.target.closest?.('[data-look-index]');
      if(card)requestAnimationFrame(()=>augmentLookbook(Number(card.dataset.lookIndex)||0));
    });
    document.addEventListener('keydown',e=>{
      if(e.key==='ArrowLeft'&&!qs('#lookbookModal')?.hidden)qs('.wc-lookbook-nav.prev')?.click();
      if(e.key==='ArrowRight'&&!qs('#lookbookModal')?.hidden)qs('.wc-lookbook-nav.next')?.click();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
